export default [
  // 后管【结算详情】模块
  // 转移记录
  {
    path: "/noPermission",
    name: "没有有权限",
    component: () => import("@/views/permission/noAccess"),
  },
];
